/// <reference path="../../Common/Helpers/GridEditorBase.ts" />

namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class POSSalesGiftVoucherEditor extends Common.GridEditorBase<POSSalesGiftVoucherRow> {
        protected getColumnsKey() { return "Retail.POSSalesGiftVoucher"; }
        protected getDialogType() { return POSSalesGiftVoucherDialog; }
        protected getLocalTextPrefix() { return POSSalesGiftVoucherRow.localTextPrefix; }
        protected form: POSSalesGiftVoucherForm;

        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public LaborMarkup: number;

        constructor(container: JQuery) {
            super(container);
            this.toolbar.findButton('add-button').find('.button-inner').text('Add GiftVoucher');
            this.slickGrid.setOptions({ rowHeight: 30 });


        }
        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);
            return grid;
        }





        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }

        public clearGrid() {
            this.view.setItems([], true);
            this.view.refresh();
            POSSalesDialog.giftcheck = false;

        }
        public setData(items: any[]) {
            let newcheck: boolean;
            this.clearGrid();
            for (var i = 0; i < items.length; i++) {
                var quantity = 0;
                if (items[i].Quantity != undefined) {
                    quantity = items[i].Quantity
                    newcheck = true;
                }
                else {
                    newcheck = false;
                }
                if (newcheck) {
                    for (var j = 0; j < items[i].Quantity; j++) {
                        let now = new Date();
                        var dt = now.getDay();
                        var mt = now.getMonth();
                        var yr = now.getUTCFullYear();
                        var hr = now.getUTCHours();
                        var mn = now.getUTCMinutes();
                        var sc = now.getUTCSeconds();
                        var msc = now.getUTCMilliseconds();


                        var temp = dt.toString() + mt.toString() + yr.toString() + hr.toString() + mn.toString() + sc.toString() + "" + msc.toString() + "";
                        var item: POSSalesGiftVoucherRow = {
                            Amount: items[i].Amount,
                            Expiry: items[i].Expiry,
                            GiftMasterId: items[i].GiftMasterId,
                            Value: items[i].Value,
                            UniqueCode: temp
                        }
                        item[this.getIdProperty()] = "'" + this.nextId++;
                        this.view.addItem(item);
                    }
                }
            }

        }
        validateEntity(row: POSSalesGiftVoucherRow, id: number) {
            if (!super.validateEntity(row, id))
                return false;
            if (row.Quantity >= 1) {
                for (var j = 1; j < row.Quantity; j++) {
                    let now = new Date();
                    var dt = now.getDay();
                    var mt = now.getMonth();
                    var yr = now.getUTCFullYear();
                    var hr = now.getUTCHours();
                    var mn = now.getUTCMinutes();
                    var sc = now.getUTCSeconds();
                    var msc = now.getUTCMilliseconds();


                    var temp = dt.toString() + mt.toString() + yr.toString() + hr.toString() + mn.toString() + sc.toString() + "" + msc.toString() + "";
                    var item: POSSalesGiftVoucherRow = {
                        Amount: row.Amount,
                        Expiry: row.Expiry,
                        GiftMasterId: row.GiftMasterId,
                        Value: row.Value,
                        UniqueCode: temp
                    }
                    item[this.getIdProperty()] = "'" + this.nextId++;
                    this.view.addItem(item);
                    
                }
                let now = new Date();
                var dt = now.getDay();
                var mt = now.getMonth();
                var yr = now.getUTCFullYear();
                var hr = now.getUTCHours();
                var mn = now.getUTCMinutes();
                var sc = now.getUTCSeconds();
                var msc = now.getUTCMilliseconds();


                var temp = dt.toString() + mt.toString() + yr.toString() + hr.toString() + mn.toString() + sc.toString() + "" + msc.toString() + "";
                row.UniqueCode = temp;
                POSSalesDialog.giftcheck = true;
                return true;

            }
                return false;
        }
    }
}